import React, { useState } from "react";
import { useSelector } from "react-redux";
import Select from "react-dropdown-select";

import { Label } from "modules/primitives";

const NewProjectTeam = ({ setFieldValue }) => {
  const {
    teamsReducer: { userTeams },
  } = useSelector((state) => state);
  const [selectedTeamOption, setSelectedTeamOption] = useState([]);

  return (
    <>
      <Label>Select a team</Label>
      <Select
        name="team_id"
        onChange={([selected]) => {
          setFieldValue("team_id", selected.value);
          setSelectedTeamOption([selected]);
        }}
        values={selectedTeamOption}
        required
        options={userTeams.map(({ id: value, name: label }) => ({
          label,
          value,
        }))}
      />
    </>
  );
};

export default NewProjectTeam;
